export default __webpack_public_path__ + "static/media/ElegantIcons.78ba4ad1.eot";